document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('contact-form');
    var formMessages = document.querySelector('.form-messege');
  
    if (!form || !formMessages) return; // ✅ Fix: skip if not present
  
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', form.getAttribute('action'), true);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          formMessages.classList.remove('error');
          formMessages.classList.add('success');
          formMessages.textContent = xhr.responseText;
          form.reset();
        } else {
          formMessages.classList.remove('success');
          formMessages.classList.add('error');
          formMessages.textContent = xhr.responseText || 'Oops! An error occurred and your message could not be sent.';
        }
      };
      xhr.send(formData);
    });
  });